import { Store, Megaphone, Truck, BarChart3, Globe, Settings } from "lucide-react";

/* IA v1 — grouping presentasi untuk ADMIN_NAV (featureRegistry tetap SSOT
   route/permission/feature gate). Item yang tidak terdaftar (Dashboard) tampil
   top-level. Grup "Website" disiapkan untuk Company Profile di masa depan. */
export const ADMIN_NAV_GROUPS = [
  { key: "store", label: "Toko", icon: Store, items: ["/admin/produk", "/admin/kategori", "/admin/pesanan", "/admin/pelanggan", "/admin/ulasan"] },
  { key: "marketing", label: "Marketing", icon: Megaphone, items: ["/admin/promo", "/admin/banner", "/admin/popup"] },
  { key: "shipping", label: "Pengiriman", icon: Truck, items: ["/admin/jubelio", "/admin/biteship", "/admin/shipping"] },
  { key: "analytics", label: "Analitik", icon: BarChart3, items: ["/admin/laporan"] },
  { key: "website", label: "Website", icon: Globe, items: ["/admin/branding", "/admin/seo", "/admin/company-profile"] },
  { key: "system", label: "Akun & Sistem", icon: Settings, items: ["/admin/tim", "/admin/langganan", "/admin/pengaturan", "/admin/tutorials"] },
];
